var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox_wrap"},[_vm._t("agreementCaseCheckbox")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }